/* Quick add from a listing card. Size still has to be chosen — curtains are sized goods —
   so the plus opens a short size list rather than guessing one. */
(() => {
  if (customElements.get('ona-quick-add')) return;
  const money = value => {
    try {
      return new Intl.NumberFormat(document.documentElement.lang || 'en-US', {
        style: 'currency',
        currency: window.Shopify?.currency?.active || 'USD'
      }).format(value / 100);
    } catch (_) { return ''; }
  };
  class OnaQuickAdd extends HTMLElement {
    connectedCallback() {
      if (this.controller) return;
      this.controller = new AbortController();
      const { signal } = this.controller;
      this.opener = this.querySelector('[data-quick-open]');
      try { this.sizes = JSON.parse(this.querySelector('[data-quick-sizes]')?.textContent || '[]'); } catch (_) { this.sizes = []; }
      this.sizes = this.sizes.filter(size => size && size.available && Number.isFinite(Number(size.id)));
      if (!this.opener || !this.sizes.length) { this.hidden = true; return; }
      this.opener.addEventListener('click', event => { event.preventDefault(); event.stopPropagation(); this.toggle(); }, { signal });
      document.addEventListener('click', event => { if (!this.contains(event.target)) this.close(); }, { signal });
      document.addEventListener('keydown', event => { if (event.key === 'Escape') this.close(); }, { signal });
    }
    toggle() { this.panel && !this.panel.hidden ? this.close() : this.open(); }
    open() {
      document.querySelectorAll('ona-quick-add').forEach(other => { if (other !== this) other.close?.(); });
      if (!this.panel) this.build();
      this.panel.hidden = false;
      this.opener.setAttribute('aria-expanded', 'true');
      this.panel.querySelector('button')?.focus({ preventScroll: true });
    }
    close() {
      if (!this.panel || this.panel.hidden) return;
      this.panel.hidden = true;
      this.opener.setAttribute('aria-expanded', 'false');
    }
    build() {
      this.panel = document.createElement('div');
      this.panel.className = 'oa-quick-add__panel';
      this.panel.hidden = true;
      const title = document.createElement('p');
      title.className = 'oa-quick-add__title';
      title.textContent = `${this.dataset.color || 'This colour'} — choose a size`;
      const list = document.createElement('div');
      list.className = 'oa-quick-add__sizes';
      this.sizes.forEach(size => {
        const button = document.createElement('button');
        button.type = 'button';
        button.className = 'oa-quick-add__size';
        button.innerHTML = `<span>${size.size}</span><span class="oa-quick-add__price">${money(size.price)}</span>`;
        button.addEventListener('click', () => this.add(size, button), { signal: this.controller.signal });
        list.append(button);
      });
      this.status = document.createElement('p');
      this.status.className = 'oa-quick-add__status';
      this.status.setAttribute('role', 'status');
      this.panel.append(title, list, this.status);
      this.append(this.panel);
    }
    async add(size, button) {
      if (this.pending) return;
      this.pending = true;
      button.classList.add('is-loading');
      this.status.textContent = '';
      const drawer = document.querySelector('cart-drawer');
      const sections = drawer?.getSectionsToRender ? drawer.getSectionsToRender().map(section => section.id).join(',') : 'cart-drawer,cart-icon-bubble';
      try {
        const response = await fetch((window.routes?.cart_add_url || '/cart/add') + '.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', Accept: 'application/javascript' },
          body: JSON.stringify({ items: [{ id: size.id, quantity: 1 }], sections, sections_url: window.location.pathname })
        });
        const result = await response.json();
        if (!response.ok || result.status) throw new Error(result.description || 'This size could not be added.');
        this.close();
        if (drawer?.renderContents) drawer.renderContents(result);
        else window.location.assign((window.Shopify?.routes?.root || '/') + 'cart');
      } catch (error) {
        this.status.textContent = error instanceof TypeError ? 'Connection interrupted. Please try again.' : error.message;
      } finally {
        button.classList.remove('is-loading');
        this.pending = false;
      }
    }
    disconnectedCallback() { this.controller?.abort(); this.controller = null; }
  }
  customElements.define('ona-quick-add', OnaQuickAdd);
})();
